import translations from './copper.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/copper'

export const copper: Metal = {
  id: 9,
  slug: 'copper',
  name: t.name,
  symbol: 'Cu',
  mines: [
    {
      name: 'Escondida (Chile, BHP/Rio Tinto)',
      region: 'Escondida',
      coordinates: [-69.25, -24.27],
    },
    {
      name: 'El Teniente (Chile, Codelco)',
      region: 'El Teniente',
      coordinates: [-70.35, -34.35],
    },
    {
      name: 'Cerro Verde (Peru, Freeport)',
      region: 'Cerro Verde',
      coordinates: [-71.57, -16.52],
    },
    {
      name: 'Las Bambas (Peru, MMG/China)',
      region: 'Las Bambas',
      coordinates: [-72.2, -14.07],
    },
    {
      name: 'Olympic Dam (Australia, BHP)',
      region: 'Olympic Dam',
      coordinates: [136.88, -30.44],
    },
  ],
  countries: [
    { name: 'Chile', percent: 23 },
    { name: 'DRC', percent: 14.3 },
    { name: 'Peru', percent: 11.3 },
    { name: 'China', percent: 7.8 },
    { name: 'USA', percent: 4.8 },
  ],
  important: true,
  // The sheet names one: lithium — paired by the electrification story rather than by
  // geology, so there is no co-product relationship to read off the mines.
  related: ['lithium'],
  video: {
    name: 'copper',
    poster: '/mine-my-phone/images/posters/copper.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 5,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'camera'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 5, ...t.supplyRisk },
    recycling: { score: 4, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'Michel Lunanga / Getty',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/07.jpg`,
          orientation: 'vertical',
          credit: 'Pes-Anders Pettersson / Getty',
        },
        {
          src: `${dir}/08.jpg`,
          orientation: 'horizontal',
          credit: 'Molly Peters',
        },
      ],
    },
  },
}
